<template>
	<div class="position-relative">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-top d-block nav-bottom">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="bg-white light-shadow-2">
                <div class="w-100">
                  <div class="row no-gutters">
                    <div class="py-2" :class="{'col-12': !right_menu,'col-7':right_menu && right_menu_data.type != 'img','col-9': right_menu && right_menu_data.type == 'img'}">
                    	<div class="w-100 pl-3">
		                    <div class="d-inline-block align-middle py-2 mr-2 cursor-pointer" @click="leftClick">
	                        <img src="../../assets/img/icon/back.png" width="25">
		                    </div>
		                    <div class="d-inline-block w-75 align-middle">
			                    <p class="body-1-2 mb-0 d-block text-truncate">
		                        {{title}}
		                      </p>
		                    </div>
	                    </div>
                    </div>
                    <div class="py-2 text-right" :class="{'col-3':right_menu_data.type == 'img', 'col-5': right_menu_data.type != 'img'}" v-if="right_menu">
                  		<div class="w-100 pr-3">
		                    <div @click="rightClick" class="pt-2 d-block cursor-pointer">
		                    	<template v-if="right_menu_data.type == 'both'">
			                    	<template v-if="right_menu_data.left == 'title'">
					                    <p class="body-2 text-green d-inline-block align-middle mb-0 mr-2 w-75 text-truncate">
				                        {{right_menu_data.title}}
				                      </p>
			                        <img :src="right_menu_data.img" class="d-inline-block align-middle" width="18">
	                  				</template>
	                  				<template v-else>
			                        <img :src="right_menu_data.img" class="d-inline-block align-middle mr-2" width="18">
					                    <p class="body-2 text-green d-inline-block align-middle mb-0 w-75 text-truncate">
				                        {{right_menu_data.title}}
				                      </p>
	                  				</template>
	                  			</template>
	                  			<template v-else-if="right_menu_data.type == 'title'">
	                  				<p class="body-2 text-green mb-0 mt-1">
			                        {{right_menu_data.title}}
			                      </p>
	                  			</template>
	                  			<template v-else>
	                  				<img :src="right_menu_data.img" width="18">
	                  			</template>
		                    </div>
	                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {mapGetters} from "vuex";
	export default {
		props:{
			title:{
				type: String,
				default: ''
			},
			url:{
				type: String,
				default: '/'
			},
			run_function:{
				type: Boolean,
				default: false
			},
			right_menu:{
				type: Boolean,
				default: false
			},
			right_menu_data:{
				type: Object,
				default() {
					return{
						type: 'title', // "title"/"img"/"both"
						title: '',
						img: '',
						left: 'title', // "title"/"img"
						url: '/',
						run_function: false 
					}
				}
			}
		},
		methods:{
			...	mapGetters(['getMerchant']),
			leftClick(){
				if(this.run_function){
					this.$emit("on-back")
				}else{
					this.$router.push({
						path: this.url
					})
				}
			},
			rightClick(){
				if(this.right_menu_data.run_function){
					this.$emit("right-on-back")
				}else{
					this.$router.push({
						path: this.right_menu_data.url
					})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/TopNavbar.vue